// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__tQf13","footer":"Form_footer__6EyX2"};